import { NavigationMockApi } from 'app/mock-api/common/navigation/api';
import { ShortcutsMockApi } from 'app/mock-api/common/shortcuts/api';
import { UserMockApi } from 'app/mock-api/common/user/api';

export const mockApiServices = [
    NavigationMockApi,
    ShortcutsMockApi,
    UserMockApi,
];
